module.exports = __webpack_public_path__ + "static/media/lock--unchecked.3cb6fcb7.svg";